module.exports = __webpack_public_path__ + "static/media/boa-hancock-win.ed0316f7.png";